<template>
	<div>
		<div class="row">
			<div class="col-md-5">
				<div class="form-group">
					<div class="custom-file">
							<input type="file"
								class="custom-file-input"
								id="customFile"
								@change="onAttachmentChange"
							>
							<label class="custom-file-label" for="customFile">Выбрать картинку заголовка</label>
					</div>
				</div>
				<img :src="eventDatas.header_img" width="600px" height="300px">
			</div>
			<div class="col-md-1"></div>
			<div class="col-md-5">
				<div class="form-group">
					<div class="custom-file">
							<input type="file"
								class="custom-file-input"
								id="customFile"
								@change="onAttachmentChange"
							>
							<label class="custom-file-label" for="customFile">Выбрать фоновую картинку</label>
					</div>
				</div>
				<img :src="eventDatas.bg_img" width="100%">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			eventDatas: []
		}
	},
	props: {
		id: {
			type: Number,
			requred: true,
			default: 200
		}
	},
	created () {
		this.getEvent()
	},
	methods: {
		getEvent () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/mailings/' + this.id, {
			}).then(function (response) {
				this.eventDatas = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onAttachmentChange (e) {
			var data = this.eventDatas
			if (e.target.files && e.target.files[0]) {
				var reader = new FileReader()
				reader.onload = function (e) {
					data.header_img = e.target.result
				}
				reader.readAsDataURL(e.target.files[0])
			}
			this.attachment = e.target.files[0]
			const config = { 'content-type': 'multipart/form-data' }
			const formData = new FormData()
			formData.append('id', this.id)
			formData.append('file', this.attachment)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/mailing/uploads', formData, config, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/mailing/AttachmentForm.vue